@if (!showExportList) {
<section class="py-3 layout-wrapper">
  <div class="container-fluid card d-flex flex-column h-100">
    <div class="flex-shrink-0">
      <div class="d-flex justify-content-between align-items-center flex-wrap mb-2">
        <app-main-heading class="col-12 col-md-3" [heading]="'Sales List'"></app-main-heading>
        <div class="col-12 col-md-9 d-flex align-items-center gap-2 justify-content-end">
          <button class="btn fw-bold filter-toggle flex-md-grow-0" (click)="openFilterPanel()"
            style="background-color: transparent; border: 1px solid #ced4da">
            <fa-icon class="me-1 text-dark" [icon]="faSliders" size="sm"></fa-icon>
            <span class="text-dark fw-bold small">Filters</span>
            <fa-icon class="ms-1" [icon]="showFilterPanel ? faAngleDown : faAngleUp" size="sm"></fa-icon>
          </button>
          <button class="btn btn-add-sale text-end m-1" [routerLink]="'/order-out'">
            Add Sale
          </button>
          <span [ngbTooltip]="!isExportEnabled ? 'Select a specific date range period to export' : ''" container="body">
            <button class="btn btn-export text-end m-1" [disabled]="!isExportEnabled || exportLoading" (click)="exportList()">
              Export
              @if (exportLoading) {
              <fa-icon class="ms-1" size="sm" [icon]="faSpinner" [animation]="'spin'"></fa-icon>
              }
            </button>
          </span>
          <fa-icon [icon]="faClockRotateLeft" (click)="showExportList = true" [ngbTooltip]="'Export History'"></fa-icon>
        </div>
      </div>
      @if (showFilterPanel) {
      <div class="card p-3 p-md-4 rounded-4 shadow-sm mb-3" style="
              background-color: #f8fafc;
              border: 1px solid #e2e8f0 !important;
            ">
        <div class="row g-2 justify-content-start align-items-end">
          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <label for="tyreSizeInput" class="filter-label">Tyre Size</label>
            <input id="tyreSizeInput" type="text" class="form-control default-form-group-border" placeholder="Search Tyre Size"
              [(ngModel)]="filtersForm.tyreSize" (ngModelChange)="onTextInputChange()" />
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <label for="brandInput" class="filter-label">Brand</label>
            <input id="brandInput" type="text" class="form-control default-form-group-border" placeholder="Search Tyre Brand"
              [(ngModel)]="filtersForm.tyreMake" (ngModelChange)="onTextInputChange()" />
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <label for="patternInput" class="filter-label">Pattern</label>
            <input id="patternInput" type="text" class="form-control default-form-group-border" placeholder="Search Tyre Model"
              [(ngModel)]="filtersForm.tyreModel" (ngModelChange)="onTextInputChange()" />
          </div>
          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <label for="saleTypeSelect" class="filter-label">Sale Type</label>
            <ng-select labelForId="saleTypeSelect" [items]="stockOutTypeList" bindLabel="name" bindValue="value" [multiple]="true"
              [closeOnSelect]="false" [clearable]="true" [searchable]="false" placeholder="Select sale types..."
              (change)="onChangeApplyFilter()" [(ngModel)]="filtersForm.stockOutType" class="custom-multi-select">
              <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                @if (items.length > 0) {
                <div class="ng-value custom-selected-badge">
                  <span class="ng-value-label selected-text">{{ items.length }} Selected</span>
                </div>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <div class="d-flex align-items-center gap-2 py-1">
                  <input type="checkbox" [checked]="item$.selected" class="form-check-input m-0 cursor-pointer" />
                  <span class="ms-1 ng-option-text selected-text">{{
                    item.name
                    }}</span>
                </div>
              </ng-template>
            </ng-select>
          </div>
          @if(isBranchVisible){
          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <label for="branchSelect" class="filter-label">Branch</label>
            <ng-select labelForId="branchSelect" [items]="companyData" bindLabel="name" bindValue="_id" [multiple]="true"
              [closeOnSelect]="false" [clearable]="true" [searchable]="false" [trackByFn]="trackById"
              placeholder="Select branches..." (change)="onChangeApplyFilter()" [(ngModel)]="filtersForm.branch"
              class="custom-multi-select">
              <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                @if (items.length > 0) {
                <div class="ng-value custom-selected-badge">
                  <span class="ng-value-label selected-text">{{ items.length }} Selected</span>
                </div>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <div class="d-flex align-items-center gap-2 py-1">
                  <input type="checkbox" [checked]="item$.selected" class="form-check-input m-0 cursor-pointer" />
                  <span class="ms-1 ng-option-text selected-text">{{
                    item.name
                    }}</span>
                </div>
              </ng-template>
            </ng-select>
          </div>
          }
          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <label for="paymentModeSelect" class="filter-label">Payment Mode</label>
            <ng-select labelForId="paymentModeSelect" [items]="paymentModeList" bindLabel="name" bindValue="value" [multiple]="true"
              [closeOnSelect]="false" [clearable]="true" [searchable]="false" placeholder="Select payment modes..."
              (change)="onChangeApplyFilter()" [(ngModel)]="filtersForm.paymentMode" class="custom-multi-select">
              <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                @if (items.length > 0) {
                <div class="ng-value custom-selected-badge">
                  <span class="ng-value-label selected-text">{{ items.length }} Selected</span>
                </div>
                }
              </ng-template>
              <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
                <div class="d-flex align-items-center gap-2 py-1">
                  <input type="checkbox" [checked]="item$.selected" class="form-check-input m-0 cursor-pointer" />
                  <span class="ms-1 ng-option-text selected-text">{{
                    item.name
                    }}</span>
                </div>
              </ng-template>
            </ng-select>
          </div>
          <!-- Period Dropdown -->
          <div class="col-12 col-sm-6 col-md-4 col-lg-3">
            <label for="dateDropdown" class="filter-label">Period</label>
            <div class="dropdown w-100">
              <button
                class="btn w-100 d-flex justify-content-between align-items-center form-control default-form-group-border"
                style="background-color: white" type="button" id="dateDropdown" data-bs-toggle="dropdown"
                aria-expanded="false">
                <span class="text-truncate selected-text" style="font-size: 13px">{{ displayRangeText || "Select Date"
                  }}</span>
              </button>
              <ul class="dropdown-menu w-100 shadow-sm custom-period-menu mt-1" aria-labelledby="dateDropdown">
                @for (item of dateRanges; track item) {
                <li class="dropdown-item cursor-pointer selected-text" style="font-size: 13px"
                  (click)="applyDaysRange(item.value)">
                  {{ item.label }}
                </li>
                }
                <li class="dropdown-item cursor-pointer fw-medium text-dark selected-text" style="font-size: 13px"
                  (click)="openCalendar()">
                  Custom Date
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      }
    </div>
    <div class="flex-grow-1 mt-3" style="min-height: 0">
      <div class="card app-table-thick-border shadow-none mb-2 h-100">
        <div class="table-responsive app-scrollbar h-100" infiniteScroll [scrollWindow]="false" [infiniteScrollDistance]="2"
          [infiniteScrollThrottle]="500" (scrolled)="onScroll()">
          <table class="table app-table-rounded align-middle m-0 w-100">
            <thead>
              <tr>
                <th>DATE/TIME</th>
                <th scope="col" class="text-center">BRANCH</th>
                <th scope="col" class="text-center">TYPE</th>
                <th scope="col">USER</th>
                <th scope="col">SKU/SERVICE DESCRIPTION</th>
                <th scope="col">QTY</th>
                <th scope="col">PRICE/UNIT</th>
                <th scope="col">TOTAL</th>
                <th scope="col">PAYMENT</th>
                <th scope="col">INVOICE</th>
                <th scope="col">ACTIONS</th>
              </tr>
            </thead>
            @if (stockOutData.length >= 1) {
            <tbody class="app-td-text">
              @for (
              order of stockOutData;
              track order;
              let orderIndex = $index
              ) {
              @for (item of order.allRows; track item; let i = $index) {
              <tr>
                @if (i === 0) {
                <td [attr.rowspan]="order.totalRows" class="td-text-one text-nowrap bottom-border">
                  <div class="d-flex flex-column gap-1">
                    <span class="text-dark">{{
                      order.formattedDateStr
                      }}</span>
                    <span class="text-dark">{{
                      order.formattedTimeStr
                      }}</span>
                  </div>
                </td>
                }
                @if (i === 0) {
                <td [attr.rowspan]="order.totalRows" class="td-text-two text-dark text-center bottom-border">
                  {{ order.branchName }}
                </td>
                }
                <!-- TYPE Column -->
                @if (item.itemType === "stock") {
                @if (i === 0) {
                <td [attr.rowspan]="order.stockCount" [class.bottom-border]="!order.serviceCount">
                  <div class="d-flex flex-column align-items-center text-center">
                    <span class="badge type-badge mb-1" [ngClass]="order.badgeClass">
                      {{ order.stockOutType | capitalSpace }}
                    </span>
                    @if (order.partnerName) {
                    <span class="td-text-two text-muted">
                      {{ order.partnerName }}
                    </span>
                    }
                  </div>
                </td>
                }
                }
                @if (item.itemType === "service") {
                @if (i === order.stockCount) {
                <td [attr.rowspan]="order.serviceCount" class="bottom-border">
                  <div class="d-flex flex-column align-items-center text-center">
                    <span class="badge type-badge mb-1 bg-return">SERVICE</span>
                    @if (!order.stockCount && order.partnerName) {
                    <span class="td-text-two text-nowrap text-muted">
                      {{ order.partnerName }}
                    </span>
                    }
                  </div>
                </td>
                }
                }
                @if (i === 0) {
                <td [attr.rowspan]="order.totalRows" class="td-text-one bottom-border">
                  {{ order.createdBy.name || "-" }}
                </td>
                }
                <!-- SKU/SERVICE DESCRIPTION -->
                <td [class.bottom-border]="i === order.allRows.length - 1">
                  <span [ngClass]="
                              item.itemType === 'stock'
                                ? 'td-text-three'
                                : 'td-text-one'
                            ">
                    @if (item.itemType === "stock") {
                    {{ item.tyreSize }} {{ item.tyreMake }}
                    {{ item.tyreModel }}
                    }
                    @if (item.itemType === "service") {
                    {{ item.label }}
                    }
                  </span>
                </td>
                <td class="td-text-one" [class.bottom-border]="i === order.allRows.length - 1">
                  @if (item.finalQuantity !== null) {
                  {{ item.finalQuantity | number}}
                  } @else {
                  -
                  }
                </td>
                <td class="td-text-one" [class.bottom-border]="i === order.allRows.length - 1">
                  @if (item.finalUnitPrice !== null) {
                  ₹{{ item.finalUnitPrice | number }}
                  } @else {
                  -
                  }
                </td>
                <td class="td-text-three" [class.bottom-border]="i === order.allRows.length - 1">
                  @if (item.value !== null) {
                  ₹{{ item.value | number }}
                  } @else {
                  -
                  }
                </td>
                @if (i === 0) {
                <td [attr.rowspan]="order.totalRows" class="td-text-one bottom-border">
                  @if (order.paymentType && order.paymentMode) {
                  {{ order.paymentType
                  }}<span class="td-text-three">:</span>
                  {{ order.paymentMode }}
                  } @else {
                  {{ order.paymentType || order.paymentMode || "-" }}
                  }
                </td>
                }
                @if (i === 0) {
                <td [attr.rowspan]="order.totalRows" class="td-text-two bottom-border"
                  (click)="viewVoucher(order, pdfModel)" [ngClass]="{
                              'text-primary cursor-pointer': order.invoice,
                            }">
                  <span>{{
                    order.replacedInvoiceNumber ||
                    order.invoiceNumber ||
                    "-"
                    }}</span>
                </td>
                }
                @if (i === 0) {
                <td [attr.rowspan]="order.totalRows" class="bottom-border text-center align-middle">
                  @if (order.hasEditAction) {
                    @if (order.fullReason) {
                    <span [ngbTooltip]="'Transaction edited. Click to view edit reason'" container="body" placement="left">
                      <button class="btn btn-sm btn-reason-log" (click)="openReasonModal(order)">
                        <fa-icon [icon]="faInfoCircle"></fa-icon>
                      </button>
                    </span>
                    } @else {
                    <span [ngbTooltip]="order.buttonTooltip" container="body" placement="left">
                      <button class="btn btn-sm btn-add-sale cursor-pointer" [disabled]="!order.canEdit" (click)="editTransaction(order)">
                        <fa-icon [icon]="faEdit"></fa-icon>
                      </button>
                    </span>
                    }
                  }
                </td>
                }
              </tr>
              }
              }
            </tbody>
            }

            @if (loader) {
              <tbody>
                <tr>
                  <td colspan="11">
                    <div class="custom-col-width-100 d-flex justify-content-center py-5">
                      <app-loader [loadingIcon]="loader"></app-loader>
                    </div>
                  </td>
                </tr>
              </tbody>
            }

            @if (!loader && stockOutData.length === 0) {
              <tbody>
                <tr>
                  <td colspan="11">
                    <div class="custom-col-width-100 text-danger d-flex justify-content-center py-5 fw-semibold">
                      No Records Found!
                    </div>
                  </td>
                </tr>
              </tbody>
            }
          </table>
        </div>
      </div>
    </div>
  </div>
</section>
}

<ng-template #pdfModel let-modal>
  <div class="app-pdf-model">
    <div class="modal-header">
      <h3 class="m-0" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 80%;">{{ selectedVocher.name }}</h3>
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </div>
    <div class="modal-body p-0">
      <iframe [src]="selectedVocher.url" class="pdf-iframe" title="PDF Document Viewer"> </iframe>
    </div>
  </div>
</ng-template>

@if (showExportList) {
<app-orders-export-list (backToSale)="showExportList = false"></app-orders-export-list>
}

@if (tosterMsg) {
<app-toaster [title]="tosterMsg" (closeToaster)="closeToster($event)"></app-toaster>
}